module.exports = __webpack_public_path__ + "img/kleisma3-m@1.9de36e7a.jpg";